import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Toast } from './../UI/toast/Toast';
import { Button, Form, FormGroup, Input, Label, Spinner } from 'reactstrap';
import withRedirect from '../../helpers/hoc/withRedirect';
import { ERROR_RESPONSE } from '../../helpers/codeResponses/codes';
import { confirmMailRequest } from '../../helpers/api/auth';
import { Message } from '../UI/preloading/PreloadState';
import { faExclamation } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';

const ConfirmEmailForm = ({ setRedirect, setRedirectUrl }) => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (email) {
      setSubmitting(true);
      try {
        await confirmMailRequest(email);
        Toast.fire({
          type: 'success',
          title: `Se ha enviado un link de verificación a ${email}`,
        });
        setRedirect(true);
      } catch ({ code }) {
        if (code === ERROR_RESPONSE.DATA_NOT_FOUND) setMessage('El correo ingresado no está registrado o ya fue verificado, si ya está registrado intente iniciar sesión, de no ser así, registrese, y verifique su cuenta.')
        Toast.fire({
          type: 'error',
          title: `Ha ocuurrido un error, espere un momento.`,
        });
      } finally {
        setSubmitting(false);
      }
    }
  }

  useEffect(() => {
    setRedirectUrl(`/authentication/confirm-mail?type=confirm&email=${email}`);
  }, [email, setRedirectUrl]);

  return <>
    <Form className="mt-4" onSubmit={handleSubmit}>
      {message && <Message color='info' className='py-2 mb-2' icon={faExclamation}>{message}</Message>}
      <FormGroup>
        <Label>Ingrese su correo electrónico y le enviaremos un enlace de verificación.</Label>
        <Input
          className="form-control"
          placeholder="Correo electrónico"
          value={email}
          onChange={({ target }) => setEmail(target.value)}
          type="email"
        />
      </FormGroup>
      <FormGroup>
        <Button color="falcon-default" block tag={Link} to='/authentication/login'>
          Volver
        </Button>
        <Button color="primary" block disabled={!email || submitting}>
          {submitting && <Spinner size='sm' className='mr-2' />}
          Enviar
        </Button>
      </FormGroup>
    </Form>
  </>
}

ConfirmEmailForm.propTypes = {
  setRedirect: PropTypes.func.isRequired,
  setRedirectUrl: PropTypes.func.isRequired,
  layout: PropTypes.string
};

export default withRedirect(ConfirmEmailForm);